// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeResultsGetByMemberBody = {
  poolId: string;
  contestId: string;
  targetUserId: string;
};

export type typeResultsGetByMemberOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    entries: {
      entryId: string;
      label: string;
      status: "in" | "eliminated" | "revived";
      pointsTotal: number;
      medalsThisContest: number;
      usedTeamIds: string[];
      selectableTeamIds: string[];
      roundsPicked: {
        roundId: string;
        label: string;
        picks: {
          eventId: string;
          teamId: string;
          outcome: "win" | "loss" | "push" | "pending";
          decisionBasis?: "spread" | "straightUp" | null;
        }[];
        participation: "picked" | "skipped" | "missed";
      }[];
    }[];
  };
};

export type typeResultsGetByMemberOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeResultsGetByMemberOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeResultsGetByMemberOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaResultsGetByMemberBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId", "targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createResultsGetByMember(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaResultsGetByMemberBody);
  }

  return async function postResultsGetByMember(
    payload: typeResultsGetByMemberBody,
  ): Promise<
    typeResultsGetByMemberOutput200 | typeResultsGetByMemberOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postResultsGetByMember" failed before calling the network. #468fbc5ccac2`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#468fbc5ccac2" },
        },
        data: null,
      } as typeResultsGetByMemberOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/results/get-by-member`,
      httpMethod: "POST",
      options,
    })) as typeResultsGetByMemberOutput200 | typeResultsGetByMemberOutput400;
  };
}
